/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free OD260 calculator. Convert a 260 nm absorbance into DNA or RNA concentration in µg/mL and ng/µL, with an optional A260/A280 purity ratio.`)
};

const es_od_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de OD260. Convierte una absorbancia a 260 nm en concentración de ADN o ARN en µg/mL y ng/µL, con una relación de pureza A260/A280 opcional.`)
};

const de_od_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser OD260-Rechner. Wandeln Sie eine Absorption bei 260 nm in eine DNA- oder RNA-Konzentration in µg/mL und ng/µL um, mit optionalem A260/A280-Reinheitsverhältnis.`)
};

const nl_od_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis OD260-calculator. Zet een absorptie bij 260 nm om naar DNA- of RNA-concentratie in µg/mL en ng/µL, met een optionele A260/A280-zuiverheidsratio.`)
};

const fr_od_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur gratuit OD260. Convertissez une absorbance à 260 nm en concentration d'ADN ou d'ARN en µg/mL et ng/µL, avec un ratio de pureté A260/A280 optionnel.`)
};

const it_od_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito di OD260. Converte un'assorbanza a 260 nm in concentrazione di DNA o RNA in µg/mL e ng/µL, con un rapporto di purezza A260/A280 opzionale.`)
};

const pt_br2_od_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de OD260. Converta uma absorbância a 260 nm em concentração de DNA ou RNA em µg/mL e ng/µL, com uma razão de pureza A260/A280 opcional.`)
};

const pt_od_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de OD260. Converta uma absorvância a 260 nm em concentração de ADN ou ARN em µg/mL e ng/µL, com um rácio de pureza A260/A280 opcional.`)
};

const ja_od_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のOD260計算ツール。260 nmの吸光度をDNAまたはRNA濃度に µg/mL および ng/µL で変換し、A260/A280純度比もオプションで計算します。`)
};

const zh_od_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费 OD260 计算器。将 260 nm 吸光度转换为 DNA 或 RNA 浓度（µg/mL 和 ng/µL），可选提供 A260/A280 纯度比。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_meta_description", locale)
	if (locale === "en") return en_od_meta_description(inputs)
	if (locale === "es") return es_od_meta_description(inputs)
	if (locale === "de") return de_od_meta_description(inputs)
	if (locale === "nl") return nl_od_meta_description(inputs)
	if (locale === "fr") return fr_od_meta_description(inputs)
	if (locale === "it") return it_od_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_od_meta_description(inputs)
	if (locale === "pt") return pt_od_meta_description(inputs)
	if (locale === "ja") return ja_od_meta_description(inputs)
	return zh_od_meta_description(inputs)
};